import React from 'react'
import {Cardwrapper, CardName, CardAvatar, CardPoster, CardInfo, CardResponse, SizeIt, Text} from "./WishCardStyle"
import { FaUserCircle, FaGlassCheers } from "react-icons/fa";

function WishCard({name, wish}) {
    
    return (
        <Cardwrapper>
            <CardName>
                <CardAvatar>
                    <FaUserCircle fontSize="20px" color="#0E8FD8" />
                </CardAvatar>
                <CardPoster>{name}</CardPoster>
            </CardName>
            <CardInfo>{wish}</CardInfo>
            <CardResponse>
                <SizeIt>
                    <FaGlassCheers fontSize="12px" color="#0E8FD8" />
                </SizeIt>
                <Text>Thanks, you are amazing.</Text>
            </CardResponse>   
        </Cardwrapper>
    )
}

export default WishCard
